import React, { useState, useRef, useMemo, useEffect } from 'react';
import { string, number } from 'prop-types';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const TruncatedText = ({ text, className, lineHeight, minimumLines }) => {
  const [truncated, toggleTruncated] = useState(true);
  const [showButton, toggleShowButton] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const element = textRef.current;
    const showButtonState = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;

    toggleShowButton(showButtonState);
  }, []);

  useEffect(() => {
    if (truncated && !showButton) {
      return;
    }

    toggleShowButton(truncated);
  }, [truncated]);

  const truncatedStyles = useMemo(() => {
    return {
      lineHeight: `${lineHeight}px`,
      maxHeight: truncated ? `${lineHeight * minimumLines}px` : '100%'
    };
  }, [lineHeight, minimumLines, truncated]);

  return (
    <div ref={textRef} style={truncatedStyles} className={`${styles.text} ${className}`}>
      {text}
      {showButton && (
        <button type="button" style={{ height: `${lineHeight}px` }} className={styles.showMoreButton} onClick={() => toggleTruncated(!truncated)}>
          {StringConstantsMixin.strings.SHOW_MORE}
        </button>
      )}
    </div>
  );
};

TruncatedText.propTypes = {
  text: string.isRequired,
  className: string,
  lineHeight: number,
  minimumLines: number
};

TruncatedText.defaultProps = {
  className: '',
  lineHeight: 22,
  minimumLines: 3
};

export default TruncatedText;
